"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _trackers = require("../../trackers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ScreenType = function ScreenType(_ref) {
  var screenType = _ref.screenType;

  if (!screenType) {
    return null;
  }

  (0, _react.useEffect)(function () {
    _trackers.pulse.update({
      device: {
        screenType: screenType
      }
    });
  }, [screenType]);
  return null;
};

ScreenType.propTypes = {
  screenType: _propTypes["default"].string
};
var _default = ScreenType;
exports["default"] = _default;
//# sourceMappingURL=ScreenType.js.map